import request from "../utils/request"

// const api = {
    // 获取用户详细信息
    export function getInfo(params) {
        return request({
            url: '/pc/member/getInfo',
            method: 'get',
            params
        })
    }
    // 注册
    export function register(data) {
        return request({
            url: '/pc/member/register',
            method: 'post',
            data: data
        })
    }
    // 登陆
    export function login(data) {
        return request({
            url: '/pc/member/login',
            method: 'post',
            data: data
        })
    }
    // 退出方法
    export function logout(data) {
        return request({
            url: '/pc/member/Logout',
            method: 'post',
            data: data
        })
    }
    // 期刊列表(分页)
    export function journalPage(params) {
        return request({
            url: '/pc/journal/query-by-page',
            method: 'get',
            params
        })
    }
    // 刊物详情
    export function journalDetail(params) {
        return request({
            url: '/pc/journal/query-detail-by-id',
            method: 'get',
            params
        })
    }
    // 各种刊物列表
    export function showjournal(params) {
        return request({
            url: '/pc/journal/show-list-by-type',
            method: 'get',
            params
        })
    }
    // 刊物类型
    export function dictData(params) {
        return request({
            url: '/system/dict/data/type',
            method: 'get',
            params
        })
    }
    // 查询字典数据详细
    export function getDict(dictCode) {
        return request({
            url: '/system/dict/data/type/' + dictCode,
            method: 'get'
        })
    }
    // 查询轮播图
    export function getBanner() {
        return request({
            url: '/pc/journal/banner-list',
            method: 'get'
        })
    }
    // 获取推广人信息
    export function getRecommender(params) {
        return request({
            url: '/pc/member/get-recommender-info',
            method: 'get',
            params
        })
    }
    // 获取用户积分余额
    export function getWallet() {
        return request({
            url: '/pc/member/get-wallet-info',
            method: 'get'
        })
    }

// }

// export default api